import { memo, useState, type FC } from 'react';

import { Box } from '@mui/material';

import heartEmpty from 'assets/playlist/heart_empty_white.svg';
import heartFull from 'assets/playlist/heart_full.png';
import { useDispatch, useSelector } from 'react-redux';
import { bamSessionUserSelector, favoritePlaylistSelector } from '@redux/session/selectors';
import { useCurrentSongSelector } from '@redux/player';
import { addToPlaylist, getCustomerPlaylists, removeFromPlaylist } from 'services/networking/playlists';
import { setCustomPlayLists } from '@redux/session';
import FlashMessage from 'components/features/FlashMessage';
import { useIntl, } from 'react-intl';

const ExperienceBar: FC = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const favoritePlaylist = useSelector(favoritePlaylistSelector);
  const currentSong = useCurrentSongSelector();
  const customer = useSelector(bamSessionUserSelector)
  const customerId = customer?.clientCode;
  const isOnPlaylist = favoritePlaylist?.playlistSongs?.map((pls) => pls.song.id).includes(currentSong?.id ?? '');
  const [showFlashMessage, setShowFlashMessage] = useState(false);

  const handleFavoriteClick = async () => {
    if (!currentSong || !favoritePlaylist || !customerId) return
    if (isOnPlaylist) {
      await removeFromPlaylist(currentSong.id, favoritePlaylist.id);
      refrechPlaylists();
    }
    else {
      if ((favoritePlaylist?.playlistSongs ?? []).length >= 100) {
        setShowFlashMessage(true);
        return;
      }
      await addToPlaylist(currentSong.id, favoritePlaylist.id);
      refrechPlaylists();
    }
  };

  const refrechPlaylists = async () => {
    if (!customerId) return;
    const playlists = await getCustomerPlaylists(customerId);
    dispatch(setCustomPlayLists(playlists));
  };


  return (
    <>
      {favoritePlaylist && <Box onClick={handleFavoriteClick} sx={{
        marginLeft: 1,
        display: 'flex',
        alignItems: 'center',
      }}>
        <img src={isOnPlaylist ? heartFull : heartEmpty} alt="Heart Empty" style={{
          width: 20,
          height: 20,
        }} />
      </Box>}
      <FlashMessage
        isShown={showFlashMessage}
        message={intl.formatMessage({ id: 'playlist.maxSongs' })}
        onClose={() => {
          setShowFlashMessage(false);
        }}
      />
    </>
  )
};

export default memo(ExperienceBar);
